import React from 'react';

const InputBar = ({onButtonSubmit, onInputChange}) => {
 return (
    <div className="tc">
         <p className="f2 white ma5 mb3">Put In Your Image Link that
          has a face and Behold the magic...</p>
          <input className="bg-light-black f2 dib ph3 ma1 pv2 br3" type="text" placeholder="Search face..." onChange={onInputChange}/>
          <button className="bg-black white f2 grow dib link ph3 pv2 dib br2" type="submit" onClick={onButtonSubmit}>Detect</button>
 </div>
    )
}
export default InputBar;